module.exports = __webpack_public_path__ + "staticVue/img/join_us01.0dadd683.jpg";